// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import { dispatchEvent } from 'fg-frontend/src/lib/dom';
import { isTouchDevice } from 'fg-frontend/plugins/utils';

const fragments = {
	HAMBURGER: '[data-fragment="Header.hamburger"]',
	MENU: '[data-fragment="Header.menu"]',
	FULLTEXT_RWD: '[data-fragment="Header.fulltextRWD"]',
	MAIN_MENU: '[data-fragment="Header.mainMenu"]',
	MENU_ITEMS: '[data-fragment="Header.menuItem"]',
	MAIN_MENU_NAV: '[data-fragment="Header.mainMenuNav"]',
	MAIN_MENU_LIST: '[data-fragment="Header.mainMenuList"]',
	ESHOP_RWD: '[data-fragment="Header.eshopRWD"]',
	C_SEC_1: '[data-fragment="Header.customSectionOne"]', // custom sections
	C_SEC_2: '[data-fragment="Header.customSectionTwo"]',
	// greedy menu
	GREEDY_MENU_TRIGGER: '[data-fragment="Header.greedyMenuTrigger"]',
	// megamenu
	OVERLAY: '[data-fragment="Header.overlay"]',
	MEGAMENU_RWD_TRIGGER: '[data-fragment="Header.megamenuRWDTrigger"]',
	MEGAMENU_RWD_TRIGGER_BACK: '[data-fragment="Header.megamenuRWDTriggerBack"]',
};

export default class Header extends WebComponent {

	constructor(props) {
		super(props);

		this.state = {
			headerScrolled: false,
			headerVisible: false,
			menuOpened: false,
			menuLvlTwoOpened: false,
			anchorsVisible: false,
			greedyMenuAvailable: false,
			greedyMenuVisible: false,
			bodyOverlayActiveClass: false,
			megamenuActive: false,
			overlayActive: false,
			greedyMenuOpened: false,
		};

		this.handleScroll = this.handleScroll.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
		this.openLevelTwo = this.openLevelTwo.bind(this);
		this.closeLevelTwo = this.closeLevelTwo.bind(this);
		this.adjustGreedyMenu = this.adjustGreedyMenu.bind(this);
		this.windowResize = this.windowResize.bind(this);
		this.handleToggleMegamenuEnter = this.handleToggleMegamenuEnter.bind(this);
		this.handleToggleMegamenuLeave = this.handleToggleMegamenuLeave.bind(this);
		this.readjustMenuItems = this.readjustMenuItems.bind(this);
	}

	didMount() {
		const self = this;
		this.body = document.body;
		// adding touch device detection and class on body accordingly
		if ( isTouchDevice() ) this.body.classList.add('touch-device');
		// setting of vars
		this.overlay = document.querySelector(fragments.OVERLAY);
		this.menu = this.element.querySelector(fragments.MENU);
		this.hamburger = this.element.querySelector(fragments.HAMBURGER);
		this.fulltextRWD = this.element.querySelector(fragments.FULLTEXT_RWD);
		this.mainMenu = this.element.querySelector(fragments.MAIN_MENU);
		this.mainMenuNav = this.element.querySelector(fragments.MAIN_MENU_NAV);
		this.mainMenuList = this.element.querySelector(fragments.MAIN_MENU_LIST);
		this.eshopRwd = this.element.querySelector(fragments.ESHOP_RWD);
		this.customSectionOne = this.element.querySelector(fragments.C_SEC_1);
		this.customSectionTwo = this.element.querySelector(fragments.C_SEC_2);
		// greedy menu vars
		this.greedyMenuTrigger = this.element.querySelector(fragments.GREEDY_MENU_TRIGGER);
		// megamenu rwd triggers
		this.magamenuRWDTrigger = this.element.querySelectorAll(fragments.MEGAMENU_RWD_TRIGGER);
		this.magamenuRWDTriggerBack = this.element.querySelectorAll(fragments.MEGAMENU_RWD_TRIGGER_BACK);

		// use of events
		window.addEventListener('scrollEnd', this.handleScroll);
		window.addEventListener('keyup', this.handleKeyboard);
		window.addEventListener('resize', this.windowResize);
		this.hamburger.addEventListener('click', this.toggleMenu);

		// open rwd level two
		this.magamenuRWDTrigger.forEach((trigger) => {
			trigger.addEventListener('click', this.openLevelTwo);
		});
		// close rwd level two
		this.magamenuRWDTriggerBack.forEach((trigger) => {
			trigger.addEventListener('click', this.closeLevelTwo);
		});

		this.lastScrollY = window.scrollY;

		// vars connected to megamenu
		this.megamenuBreakpoint = 768;
		this.megamenuTimerInterval = 300;
		this.hoverClass = 'hover';
		this.megamenuActiveItem = '';
		this.waitingForMegamenuItem = '';

		// width checker helper
		this.isTabletOrWider = window.innerWidth >= this.megamenuBreakpoint;

		// initial setup fr greedy menu
		this.hiddenLinks = document.createElement('ul');
		this.hiddenLinks.classList.add('hidden-links');
		this.hiddenLinks.classList.add('links-invisible');
		this.visibleLinks = this.mainMenuList;
		this.visibleLinks.classList.add('visible-links');
		this.triggerBack = document.createElement('button');
		this.triggerBack.innerHTML = this.greedyMenuTrigger.innerHTML;
		this.triggerBack.classList.add('greedy-menu__trigger');
		this.triggerBack.classList.add('greedy-menu__trigger--back');
		this.hiddenLinks.appendChild(this.triggerBack); // add trigger to be allowed to step back in menu
		this.breakpoints = []; // prep empty array to push breakpoints
		// calculate breakpoints
		let childrenSize = 0;
		for (let i = 0; i < this.visibleLinks.children.length; i++) {
			!this.isTabletOrWider ? childrenSize += this.visibleLinks.children[ i ].offsetHeight : childrenSize += this.visibleLinks.children[ i ].offsetWidth;
			this.breakpoints[ i ] = childrenSize;
		}

    // eshop links - had to duplicate :(
    this.rwdEshopLinks = document.querySelector('.header__rwd-eshop');
    this.rwdEshopLinksClone = this.rwdEshopLinks.cloneNode(true);


		// update menu
		this.adjustGreedyMenu();

		// handle mouse events
		this.menuItems = this.element.querySelectorAll(fragments.MENU_ITEMS);

		this.menuItems.forEach((item) => {
			item.addEventListener('mouseenter', this.handleToggleMegamenuEnter);
			item.addEventListener('mouseleave', this.handleToggleMegamenuLeave);
		});

		if (!isTouchDevice() && this.isTabletOrWider) {
			this.greedyMenuTrigger.addEventListener('mouseenter', this.handleToggleMegamenuEnter);
			this.greedyMenuTrigger.addEventListener('mouseleave', this.handleToggleMegamenuLeave);
		}
	}

	willUnMount() {
		window.removeEventListener('scrollEnd', this.handleScroll);
		window.removeEventListener('keyup', this.handleKeyboard);
		window.removeEventListener('resize', this.windowResize);
		this.hamburger.removeEventListener('click', this.toggleMenu);
		this.magamenuRWDTrigger.forEach((trigger) => {
			trigger.addEventListener('click', this.openLevelTwo);
		});
		this.magamenuRWDTriggerBack.forEach((trigger) => {
			trigger.addEventListener('click', this.closeLevelTwo);
		});
		this.menuItems.forEach((item) => {
			item.removeEventListener('mouseenter', this.handleToggleMegamenuEnter);
			item.removeEventListener('mouseleave', this.handleToggleMegamenuLeave);
		});
		this.greedyMenuTrigger.removeEventListener('mouseenter', this.handleToggleMegamenuEnter);
		this.greedyMenuTrigger.removeEventListener('mouseleave', this.handleToggleMegamenuLeave);
	}

	openLevelTwo(e) {
		this.mainMenuList.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
		setTimeout(() => {
			this.setState({
				menuLvlTwoOpened: true,
			});
		}, this.megamenuTimerInterval);

		e.target.nextElementSibling.classList.add('visible');
    this.rwdEshopLinksClone.classList.add('header__rwd-eshop--cloned');
		e.target.nextElementSibling.appendChild(this.rwdEshopLinksClone);
	}

	closeLevelTwo(e) {
		this.setState({
			menuLvlTwoOpened: false,
		});
		e.target.closest('.megamenu').classList.remove('visible');
		e.target.closest('.megamenu').querySelector('.header__rwd-eshop--cloned').remove();
	}

	// enter megamenu
	handleToggleMegamenuEnter(e) {
		if (this.isTabletOrWider) {
			this.megamenuCurrentItem = e.target;

			const megamenu = this.megamenuCurrentItem.querySelector('.megamenu');
			const hiddenLinks = this.megamenuCurrentItem.querySelector('.hidden-links');

			if (megamenu || hiddenLinks) {

				this.setState({
					bodyOverlayActiveClass: true,
					megamenuActive: true,
					overlayActive: true,
				});

				if (this.megamenuActiveItem == '') {
					this.megamenuActiveItem = e.target;
					clearTimeout(this.timer);
					this.waitingForMegamenuClose = false;
					this.megamenuActiveItem.classList.add(this.hoverClass);
				} else if (e.target == this.megamenuActiveItem) {
					this.waitingForMegamenuClose = false;
					clearTimeout(this.timer);
				} else {
					this.waitingForMegamenuItem = e.target;
					this.waitingForMegamenuClose = true;
				}
			}
		}
	}

	// leave megamenu
	handleToggleMegamenuLeave(e) {
		if (this.isTabletOrWider) {
			const megamenu = this.megamenuCurrentItem.querySelector('.megamenu');
			const hiddenLinks = this.megamenuCurrentItem.querySelector('.hidden-links');

			if (megamenu || hiddenLinks) {
				this.setState({
					bodyOverlayActiveClass: false,
					megamenuActive: false,
					overlayActive: false,
				});
				clearTimeout(this.timer);
				this.megamenuCurrentItem = '';
				this.timer = window.setTimeout(() => {
					this.megamenuActive = false;
					if (this.megamenuActiveItem != '') {
						this.megamenuActiveItem.classList.remove(this.hoverClass);
						this.megamenuActiveItem = '';
					}
					if (this.waitingForMegamenuClose) {
						this.waitingForMegamenuClose = false;
						if (this.megamenuCurrentItem != '') {
							dispatchEvent(this.waitingForMegamenuItem, 'mouseenter');
						}
					}
				}, this.megamenuTimerInterval);
			}
		}
	}

  handleScroll = () => {
  	const { scrollY } = window;

  	// force `open` state when menu is opened a `scroll` is consequence of missing scrollbar
  	const { menuOpened } = this.state;
  	if (menuOpened) return;

  	if (scrollY > 300) {
  		this.setState({
  			headerScrolled: true,
  			anchorsVisible: true,
  		});
  		if (scrollY > this.lastScrollY) {
  			this.setState({
  				headerVisible: false,
  				anchorsVisible: true,
  			});
  		} else {
  			this.setState({
  				headerVisible: true,
  				anchorsVisible: false,
  			});
  		}
  	} else {
  		this.setState({
  			headerScrolled: false,
  			headerVisible: false,
  			anchorsVisible: true,
  		});
  	}

  	this.lastScrollY = scrollY <= 0 ? 0 : scrollY;
  }

  toggleMenu = () => {
  	const { menuOpened } = this.state;

  	this.setState({
  		menuOpened: !menuOpened,
  		overlayActive: !menuOpened,
  		headerScrolled: false,
  	});

  	// hide megamenu if opened
  	this.megamenu = document.querySelectorAll('.megamenu');
  	this.megamenu.forEach((megamenu) => {
  		if (megamenu.classList.contains('visible')) {
  			megamenu.classList.remove('visible');
  		}
  	});
  	// hide greedy if opened
  	this.greedymenu = document.querySelector('.hidden-links');
  	if (!this.greedymenu.classList.contains('links-invisible')) {
  		this.greedymenu.classList.add('links-invisible');
      this.setState({
        greedyMenuOpened: false
      });
  	}

  	this.adjustGreedyMenu();
  }

  readjustMenuItems = () => {
  	const container = document.querySelector('.hidden-links');
  	const items = container.childNodes;
  	items.forEach((item) => {
  		item.removeAttribute('data-fragment');
  	});
  }

  adjustGreedyMenu = () => {
  	!this.isTabletOrWider ? this.mainMenuNav.appendChild(this.hiddenLinks) : this.greedyMenuTrigger.appendChild(this.hiddenLinks);

  	const self = this;

  	// update menu
  	let availableSpace;
  	!this.isTabletOrWider ? availableSpace = this.mainMenuNav.offsetHeight - this.greedyMenuTrigger.offsetHeight : availableSpace = this.mainMenuNav.offsetWidth - this.greedyMenuTrigger.offsetWidth;
  	let itemsVisible = this.visibleLinks.children.length;

  	const greedyMenuTrigger1 = this.element.querySelectorAll('.greedy-menu__trigger-1');
  	const greedyMenuTrigger2 = this.element.querySelectorAll('.greedy-menu__trigger-2');

  	if (itemsVisible == 0) {
  		greedyMenuTrigger1.forEach((item) => { item.classList.remove('hidden'); });
  		greedyMenuTrigger2.forEach((item) => { item.classList.add('hidden'); });
  	} else {
  		greedyMenuTrigger1.forEach((item) => { item.classList.add('hidden'); });
  		greedyMenuTrigger2.forEach((item) => { item.classList.remove('hidden'); });
  	}

  	/*
      Check if there is not enough space for the visible links or
      if there is space available for the hidden link
    */
  	if (availableSpace < this.breakpoints[ itemsVisible - 1 ]) {
  		this.setState({
  			greedyMenuAvailable: true,
  			greedyMenuVisible: true,
  		});

  		while (availableSpace < this.breakpoints[ itemsVisible - 1 ]) {
  			this.hiddenLinks.insertBefore(this.visibleLinks.children[ itemsVisible - 1 ], this.hiddenLinks.firstChild);
  			itemsVisible--;
  			this.readjustMenuItems(); // this is to make sure mouse leave event on megamenu will not trigger
  		}
  	} else if (availableSpace > this.breakpoints[ itemsVisible ]) {
  		while (availableSpace > this.breakpoints[ itemsVisible ]) {
  			this.visibleLinks.appendChild(this.hiddenLinks.removeChild(this.hiddenLinks.firstChild));
  			itemsVisible++;
  			this.readjustMenuItems(); // this is to make sure mouse leave event on megamenu will not trigger
  		}
  	}

  	if (isTouchDevice() && this.isTabletOrWider) {
  		this.greedyMenuTrigger.addEventListener('click', (e) => {
  			e.target.classList.toggle('hover');
  			if (e.target.classList.contains('hover')) {
  				this.setState({
  					menuOpened: true,
  					overlayActive: true,
  				});
  			} else {
  				this.setState({
  					menuOpened: false,
  					overlayActive: false,
  				});
  			}
  		});
  	}

    // if NOT on tablet or wider
  	if (!this.isTabletOrWider) {

  		this.greedyMenuTrigger.addEventListener('click', () => {
  			this.setState({
  				greedyMenuOpened: true,
  			});
  			self.hiddenLinks.classList.remove('links-invisible');
        // put in rwd eshop header links
        this.rwdEshopLinksClone.classList.add('header__rwd-eshop--cloned');
        self.hiddenLinks.appendChild(this.rwdEshopLinksClone);
        // scroll up
  			this.mainMenuList.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  		});

  		this.triggerBack.addEventListener('click', () => {
  			this.setState({
  				greedyMenuOpened: false,
  			});
  			self.hiddenLinks.classList.add('links-invisible');
        self.hiddenLinks.querySelector('.header__rwd-eshop--cloned').remove();
  		});
  	}
  }

  windowResize = () => {
  	// width checker helper
  	this.isTabletOrWider = window.innerWidth >= this.megamenuBreakpoint;
    if (this.isTabletOrWider) {
      this.adjustGreedyMenu();
    }

  	this.readjustMenuItems();
  	if (this.isTabletOrWider && this.element.classList.contains('menu-opened')) this.closeMenu();
  }

  closeMenu = () => {
  	this.setState({
  		menuOpened: false,
  		overlayActive: false,
      greedyMenuOpened: false,
  	});
  }

  handleKeyboard = (e) => {
  	switch (e.key) {
  		case 'Escape':
  			this.closeMenu();
  			break;
  	}
  }

  update() {
  	const {
  		headerScrolled,
  		headerVisible,
  		menuOpened,
  		menuLvlTwoOpened,
  		anchorsVisible,
  		bodyOverlayActiveClass,
  		overlayActive,
  		megamenuActive,
  		greedyMenuOpened,
  	} = this.state;

  	// megamenu
  	classNames(this.body, { 'overlay--active': bodyOverlayActiveClass });
  	classNames(this.body, { 'megamenu--active': megamenuActive });
  	classNames(this.overlay, { active: overlayActive });

  	classNames(this.element, { 'header--scrolled': headerScrolled });
  	classNames(this.element, { 'header--visible': headerVisible });
  	classNames(this.element, { 'menu-opened': menuOpened });
  	classNames(this.menu, { 'header__menu--active': menuOpened });
  	classNames(this.menu, { 'header__menu--lvl-two-opened': menuLvlTwoOpened });
  	classNames(this.menu, { 'header__menu--greedy-menu-opened': greedyMenuOpened }); // greedy menu
  	classNames(this.hamburger, { active: menuOpened });
  	classNames(document.body, { 'menu-opened': menuOpened });
  	classNames(this.fulltextRWD, { hidden: menuOpened });
  	classNames(document.body, { 'header--scrolled': headerScrolled });
  	classNames(document.body, { 'header--visible': headerVisible });
  	classNames(document.body, { 'anchors--visible': anchorsVisible });
  }
}




// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/Header/Header.js